document.addEventListener('rebuy:cart.add', (event) => {
  var item = event.detail.item;
  var ProVariantID = item.variant_id;
  var ProductID = item.product_id;
  var ProductHandle = item.handle;
  var isDefaultVariant = item.product_has_only_default_variant;
  var lineItemKey = item.key;
  var lineItemQty = item.quantity;
  console.log('[RLT] fired | isDefault:', isDefaultVariant, '| ProductID:', ProductID, '| handle:', ProductHandle, '| VariantID:', ProVariantID, '| key:', lineItemKey);

const endpoint = 'https://house-ofleon.myshopify.com/api/2024-04/graphql';
const headers = new Headers({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'X-Shopify-Storefront-Access-Token': 'fb7d74bd378f93aa443f0fb8ee8ade42'
});

const getShopifyProductTypes = async () => {
  try {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ query: query() })
  });
  const data = await response.json();
  console.log('[RLT] API response:', JSON.stringify(data));
  var node = data && data.data && (data.data.node || data.data.product);
  if (!node) { return; }
  var MetaVal = node.metafield && node.metafield.value;
  console.log('[RLT] MetaVal:', MetaVal);
  if (!MetaVal) { return; }

  let newText = MetaVal.replace(/Arriving to our warehouse:/, '');
  var NewUpdatedValue = newText.trim();
  let result = MetaVal.includes('Arriving to our warehouse:');
  let newTextReady = MetaVal.replace(/^In Stock \+ /, '').split('\n')[0].trim();

  var properties = {};
  if (result) {
    properties['Arriving to our warehouse'] = NewUpdatedValue;
  } else {
    properties['Availability'] = newTextReady;
  }

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineItemKey, quantity: lineItemQty, properties }),
  });
  document.dispatchEvent(new CustomEvent('theme:cart:add'));
  } catch(e) { console.error('rebuy_lead_time error:', e); }
}

const query = () => {
  var q = isDefaultVariant
    ? `{ product(handle: "${ProductHandle}") { metafield(namespace: "custom", key: "shippingdetails") { value } } }`
    : `{ node(id: "gid://shopify/ProductVariant/${ProVariantID}") { ... on ProductVariant { metafield(namespace: "custom", key: "shippingdetails") { value } } } }`;
  console.log('[RLT] query:', q);
  return q;
};

getShopifyProductTypes();

});
// console.log("========");
// Console.log(ProVariantID)
// console.log("========");





